import styled from 'styled-components';

export const SwitchInput = styled.label`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;
`;

export const SwitchCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #005f47;
  }

  &:focus + span {
    box-shadow: 0 0 1px #005f47;
  }

  &:checked + span::before {
    transform: translateX(14px);
  }
`;

export const SwitchBody = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.4s;

  &::before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.4s;
  }
`;
